export class BaseSalary {
    '@type': string;
    currency: string;
    value: string;
    constructor(currency: string, value: string) {
        this.currency = currency;
        this.value = value;
        this['@type'] = 'MonetaryAmount';
    }
}
